module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "fixed",
      "left": "0",
      "right": "0",
      "top": "0",
      "bottom": "0",
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "margin": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "display": "table"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "table-cell",
      "text-align": "center",
      "vertical-align": "middle"
    }
  }, [_c('div', {
    staticClass: "loader vertical-align-middle loader-cube-grid center-block"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc502874!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingIndicator.vue
// module id = 559
// module chunks = 1